import sortBy from 'lodash/sortBy';

// TODO: Can strip the Other and Non-Denominational out, and make this simply an alphabetize util function
export default function alphabetizeTraditions(traditions) {
  const nonDenominationalTemplate = traditions.filter(t => t.title === 'Non-Denominational');
  const otherTemplate = traditions.filter(t => t.title === 'Other');
  const remainingTemplatesAlphabetized = sortBy(traditions.filter(t => t.title !== 'Non-Denominational' && t.title !== 'Other'), [t => t.title]);
  return [...nonDenominationalTemplate, ...remainingTemplatesAlphabetized, ...otherTemplate];
}



// WEBPACK FOOTER //
// ./src/util/alphabetizeTraditions.js